/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Plan } from 'cio/utils/billing/plans';

interface AvailablePlanGridArgs {
  plans: Plan[];
  nextUpgradePlanType: Plan;
  showStartupPlans: boolean;
  hideExpirationLabel?: boolean;
}

export default class AvailablePlanGrid extends Component<AvailablePlanGridArgs> {
  @tracked showCheckout = false;
}
